import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators  } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { DateAdapter } from '@angular/material/core';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LoaderService } from "src/app/Services/loader.service";
declare const Swal;

@Component({
  selector: 'g10-roster-dashboard-trip-logs',
  templateUrl: './roster-dashboard-trip-logs.component.html',
  styleUrls: ['./roster-dashboard-trip-logs.component.css']
})
export class RosterDashboardTripLogsComponent implements OnInit {

  constructor(
    public api: ApiService,
    public com: CommonServices,
    private dateAdapter: DateAdapter<Date>,
    public excel: ExcelExportService,
    public storage: StorageService,
    public swal: SweetAlert,
    public route:Router,
    private loader: LoaderService
    ) {
    this.userData = this.storage.get('userInfo')
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy  
  }
  matFormSize = '13px';
  ngOnInit(): void {
    this.filterFormLoad();
    this.getRosterDetails({
      tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
      default: true,
    })
    this.getRouteData();
    this.getBranchList();
    this.createRosterFormLoad();
    this.vehSwapFormLoad();
    this.addEditEmployeeForm();
    this.mergeFormLoad();
    // this.mergeEmpFormLoad();
    this.getVendorsAndDriverAndVehicleList();
    this.minDate.setDate(this.minDate.getDate() - 1);
    this.maxEndDate.setDate(this.minDate.getDate() + 59);
  }
  public filterForm: FormGroup;
  public todayDate = new Date();
  public tableData: any = [
    // {
    //   "orgID": "63db6171ae6d109917f74a83",
    //   "routeID": "63f5d60b94c9278b5fa29164",
    //   "tripDate": 1683138600000,
    //   "tripsheetID": "P17479594121715",
    //   "transitMode": "Pickup",
    //   "title": "Login",
    //   "vehRegNo": "TN60SA1561",
    //   "tripStartTime": null,
    //   "tripEndTime": null,
    //   "empInfo": [
    //     {
    //       "eta": 9.12,
    //       "etaStr": "09:12",
    //       "empRefID": "G10-0124",
    //       "name": "Mathan ",
    //       "employeeID": "63dccff2828385c669365b6a",
    //       "mobile": 9822342232,
    //       "address": "guindy",
    //       "project": "Developement ",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 13.0066625,
    //         "lng": 80.2206369
    //       },
    //       "atten": true,
    //       "attenTime":"15:00",
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     },
    //     {
    //       "eta": 9.12,
    //       "etaStr": "09:12",
    //       "empRefID": "G10-0121",
    //       "name": "vasudevan",
    //       "employeeID": "63db7550ae6d109917f74a9b",
    //       "mobile": 8220937255,
    //       "address": "guindy",
    //       "project": "Developement ",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 13.0066625,
    //         "lng": 80.2206369
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     }
    //   ],
    //   "driverInfo": {
    //     "name": "Surya",
    //     "number": 7449281561,
    //     "driverID": "63dcb075828385c669365b58"
    //   },
    //   "branchInfo": {
    //     "name": "Velachery",
    //     "location": {
    //       "lat": 12.92417,
    //       "lng": 80.11654,
    //       "name": "Tambaram Bridge ، 603101 Tambaram، India"
    //     },
    //     "branchID": "644b5ccb0f29e1e2751ef55f"
    //   },
    //   "shiftTime": 17.15,
    //   "shiftTimeStr": "17:15",
    //   "vendor": "Groupten",
    //   "status": 1,
    //   "createdAt": 1683174795941,
    //   "createdBy": "vivek@groupten.com",
    //   "rosterID": "6453358b8ecbe38e68494fe7"
    // },
    // {
    //   "orgID": "63db6171ae6d109917f74a83",
    //   "routeID": "64006923f158136e8939b861",
    //   "tripDate": 1683138600000,
    //   "tripsheetID": "D17479594122100",
    //   "transitMode": "Drop",
    //   "title": "Logout",
    //   "vehRegNo": "TN01AA1111",
    //   "tripStartTime": null,
    //   "tripEndTime": null,
    //   "empInfo": [
    //     {
    //       "eta": 9.12,
    //       "etaStr": "09:12",
    //       "empRefID": "G10-0124",
    //       "name": "Mathan ",
    //       "employeeID": "63dccff2828385c669365b6a",
    //       "mobile": 9822342232,
    //       "address": "Guindy",
    //       "project": "Developement ",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 13.0066625,
    //         "lng": 80.2206369
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     },
    //     {
    //       "eta": 9.12,
    //       "etaStr": "09:12",
    //       "empRefID": "G10-0121",
    //       "name": "vasudevan",
    //       "employeeID": "63db7550ae6d109917f74a9b",
    //       "mobile": 8220937255,
    //       "address": "Guindy",
    //       "project": "Developement ",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 13.0066625,
    //         "lng": 80.2206369
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     }
    //   ],
    //   "driverInfo": {
    //     "name": "jhkh",
    //     "number": 1234567894,
    //     "driverID": null
    //   },
    //   "branchInfo": {
    //     "name": "Velachery",
    //     "location": {
    //       "lat": 12.92417,
    //       "lng": 80.11654,
    //       "name": "Tambaram Bridge ، 603101 Tambaram، India"
    //     },
    //     "branchID": "644b5ccb0f29e1e2751ef55f"
    //   },
    //   "shiftTime": 21,
    //   "shiftTimeStr": "21:00",
    //   "vendor": "Mathan",
    //   "status": 1,
    //   "createdAt": 1683174795941,
    //   "createdBy": "vivek@groupten.com",
    //   "rosterID": "6453358b8ecbe38e68494fe8"
    // },
    // {
    //   "orgID": "63db6171ae6d109917f74a83",
    //   "routeID": "63f5d60b94c9278b5fa29164",
    //   "tripDate": 1683138600000,
    //   "tripsheetID": "P17479594161615",
    //   "transitMode": "Pickup",
    //   "title": "Login",
    //   "vehRegNo": "TN01AA1112",
    //   "tripStartTime": null,
    //   "tripEndTime": null,
    //   "empInfo": [
    //     {
    //       "eta": 5,
    //       "etaStr": "05:00",
    //       "empRefID": "123QWE",
    //       "name": "Karun",
    //       "employeeID": "6415980cea2f6f2a19af7916",
    //       "mobile": 9600993737,
    //       "address": "Velachery",
    //       "project": "Development",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 12.9815179,
    //         "lng": 80.2179755
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     },
    //     {
    //       "eta": 5.3,
    //       "etaStr": "05:30",
    //       "empRefID": "BRD-001",
    //       "name": "Vimal",
    //       "employeeID": "6400495ae9923e420207b716",
    //       "mobile": 9600993737,
    //       "address": "Velachery",
    //       "project": "Development",
    //       "gender": "Male",
    //       "atten": true,
    //       "attenTime":"13:00",
    //       "location": {
    //         "lat": 12.9815179,
    //         "lng": 80.2179755
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     },
    //     {
    //       "eta": 5.45,
    //       "etaStr": "05:45",
    //       "empRefID": "IN5-330",
    //       "name": "Prasan",
    //       "employeeID": "63edd03c346d5293887b7279",
    //       "mobile": 8072648849,
    //       "address": "Velachery",
    //       "project": "HR",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 12.9815179,
    //         "lng": 80.2179755
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     },
    //     {
    //       "eta": 5.45,
    //       "etaStr": "05:45",
    //       "empRefID": "G10-0124",
    //       "name": "Mathan ",
    //       "employeeID": "63dccff2828385c669365b6a",
    //       "mobile": 9822342232,
    //       "address": "Velachery",
    //       "project": "HR",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 12.9815179,
    //         "lng": 80.2179755
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     }
    //   ],
    //   "driverInfo": {
    //     "name": "Kanna",
    //     "number": 9952413037,
    //     "driverID": null,
    //     "imei": "d48069c90e3f3ae9"
    //   },
    //   "branchInfo": {
    //     "name": "Velachery",
    //     "location": {
    //       "lat": 12.92417,
    //       "lng": 80.11654,
    //       "name": "Tambaram Bridge ، 603101 Tambaram، India"
    //     },
    //     "branchID": "644b5ccb0f29e1e2751ef55f"
    //   },
    //   "shiftTime": 16.15,
    //   "shiftTimeStr": "16:15",
    //   "vendor": null,
    //   "status": 1,
    //   "createdAt": 1683174795941,
    //   "createdBy": "vivek@groupten.com",
    //   "rosterID": "6453358b8ecbe38e68494fe9"
    // },
    // {
    //   "orgID": "63db6171ae6d109917f74a83",
    //   "routeID": "64006923f158136e8939b861",
    //   "tripDate": 1683138600000,
    //   "tripsheetID": "D17479594162000",
    //   "transitMode": "Drop",
    //   "title": "Logout",
    //   "vehRegNo": "TN01AA1112",
    //   "tripStartTime": null,
    //   "tripEndTime": null,
    //   "empInfo": [
    //     {
    //       "eta": 18.45,
    //       "etaStr": "18:45",
    //       "empRefID": "123QWE",
    //       "name": "Karun",
    //       "employeeID": "6415980cea2f6f2a19af7916",
    //       "mobile": 9600993737,
    //       "address": "Gii",
    //       "project": "Development",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 13.081753,
    //         "lng": 79.957771,
    //         "name": "602025, Thiruvallur, Tamil Nadu, India"
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     },
    //     {
    //       "eta": 19.45,
    //       "etaStr": "19:45",
    //       "empRefID": "BRD-001",
    //       "name": "Vimal",
    //       "employeeID": "6400495ae9923e420207b716",
    //       "mobile": 9600993737,
    //       "address": "chennai",
    //       "project": "Development",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 12.991087445323993,
    //         "lng": 80.24316663025812,
    //         "name": "chennai"
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     },
    //     {
    //       "eta": 20.45,
    //       "etaStr": "20:45",
    //       "empRefID": "IN5-330",
    //       "name": "Prasan",
    //       "employeeID": "63edd03c346d5293887b7279",
    //       "mobile": 8072648849,
    //       "address": "Taramani",
    //       "project": "HR",
    //       "gender": "Male",
    //       "location": null,
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     },
    //     {
    //       "eta": 20.45,
    //       "etaStr": "20:45",
    //       "empRefID": "G10-0124",
    //       "name": "Mathan ",
    //       "employeeID": "63dccff2828385c669365b6a",
    //       "mobile": 9822342232,
    //       "address": "Chrompet",
    //       "project": "HR",
    //       "atten": true,
    //       "attenTime":"15:00",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 12.945993,
    //         "lng": 80.143603,
    //         "name": "No:1, G-1, sai kamakshi apartment, 1st Cross St, State Bank Staff Colony, Chromepet, Chennai, Tamil Nadu 600044, India"
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     }
    //   ],
    //   "driverInfo": {
    //     "name": "jhkh",
    //     "number": 1234567894,
    //     "driverID": null
    //   },
    //   "branchInfo": {
    //     "name": "Velachery",
    //     "location": {
    //       "lat": 12.92417,
    //       "lng": 80.11654,
    //       "name": "Tambaram Bridge ، 603101 Tambaram، India"
    //     },
    //     "branchID": "644b5ccb0f29e1e2751ef55f"
    //   },
    //   "shiftTime": 20,
    //   "shiftTimeStr": "20:00",
    //   "vendor": null,
    //   "status": 1,
    //   "createdAt": 1683174795941,
    //   "createdBy": "vivek@groupten.com",
    //   "rosterID": "6453358b8ecbe38e68494fea"
    // },
    // {
    //   "orgID": "63db6171ae6d109917f74a83",
    //   "routeID": "63f5d60b94c9278b5fa29164",
    //   "tripDate": 1683138600000,
    //   "tripsheetID": "P174795941112300",
    //   "transitMode": "Pickup",
    //   "title": "Login",
    //   "vehRegNo": "TN01AA1113",
    //   "tripStartTime": null,
    //   "tripEndTime": null,
    //   "empInfo": [
    //     {
    //       "eta": 4.3,
    //       "etaStr": "04:30",
    //       "empRefID": "G10-01212",
    //       "name": "Parameswara Rao",
    //       "employeeID": "63e337c299ae332b1886cd99",
    //       "mobile": 8977485285,
    //       "address": "Guindy",
    //       "project": "Development",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 13.0066625,
    //         "lng": 80.2206369
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     },
    //     {
    //       "eta": 3.45,
    //       "etaStr": "03:45",
    //       "empRefID": "TC5-333",
    //       "name": "Arockiya raja",
    //       "employeeID": "63e08bb5828385c669365b7e",
    //       "mobile": 7358662038,
    //       "address": "5 A, Naidu Shop St, Srinivasapuram, Chromepet, Chennai, Tamil Nadu 600044",
    //       "project": "HR",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 12.9523064,
    //         "lng": 80.146535
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     }
    //   ],
    //   "driverInfo": {
    //     "name": "Siva",
    //     "number": 8977485285,
    //     "driverID": null
    //   },
    //   "branchInfo": {
    //     "name": "Velachery",
    //     "location": {
    //       "lat": 12.92417,
    //       "lng": 80.11654,
    //       "name": "Tambaram Bridge ، 603101 Tambaram، India"
    //     },
    //     "branchID": "644b5ccb0f29e1e2751ef55f"
    //   },
    //   "shiftTime": 23,
    //   "shiftTimeStr": "23:00",
    //   "vendor": null,
    //   "status": 1,
    //   "createdAt": 1683174795941,
    //   "createdBy": "vivek@groupten.com",
    //   "rosterID": "6453358b8ecbe38e68494feb"
    // },
    // {
    //   "orgID": "63db6171ae6d109917f74a83",
    //   "routeID": "64006923f158136e8939b861",
    //   "tripDate": 1683138600000,
    //   "tripsheetID": "D174795941112355",
    //   "transitMode": "Drop",
    //   "title": "Logout",
    //   "vehRegNo": "TN01AA1113",
    //   "tripStartTime": null,
    //   "tripEndTime": null,
    //   "empInfo": [
    //     {
    //       "eta": 18.45,
    //       "etaStr": "18:45",
    //       "empRefID": "G10-01212",
    //       "name": "Parameswara Rao",
    //       "employeeID": "63e337c299ae332b1886cd99",
    //       "mobile": 8977485285,
    //       "address": "taramani",
    //       "project": "Development",
    //       "gender": "Male",
    //       "location": null,
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     },
    //     {
    //       "eta": 19.45,
    //       "etaStr": "19:45",
    //       "empRefID": "TC5-333",
    //       "name": "Arockiya raja",
    //       "employeeID": "63e08bb5828385c669365b7e",
    //       "mobile": 7358662038,
    //       "address": "Vellore",
    //       "project": "HR",
    //       "gender": "Male",
    //       "location": {
    //         "lat": 12.95745,
    //         "lng": 80.18377,
    //         "name": "X54M+XGC, Thiruvalluvar Nagar Main Rd, Thiruvalluvar Nagar, Keelkattalai, Chennai, Tamil Nadu 600117, India"
    //       },
    //       "isAssigned": true,
    //       "userType": "Employee",
    //       "area": "Vadapalani",
    //       "landmark": null
    //     }
    //   ],
    //   "driverInfo": {
    //     "name": "jhkh",
    //     "number": 1234567894,
    //     "driverID": null
    //   },
    //   "branchInfo": {
    //     "name": "Velachery",
    //     "location": {
    //       "lat": 12.92417,
    //       "lng": 80.11654,
    //       "name": "Tambaram Bridge ، 603101 Tambaram، India"
    //     },
    //     "branchID": "644b5ccb0f29e1e2751ef55f"
    //   },
    //   "shiftTime": 23.55,
    //   "shiftTimeStr": "23:55",
    //   "vendor": null,
    //   "status": 1,
    //   "createdAt": 1683174795941,
    //   "createdBy": "vivek@groupten.com",
    //   "rosterID": "6453358b8ecbe38e68494fec"
    // }
  ];
  public sourceRouteData:any=[];
  public responseData: any = [];
  public filterFormSubmit: boolean = false;
  public excelData: any = [];

  // Selection area variables
  public vehArrays: any = [];
  public shiftListArr: any = [];
  public dropShiftArr:any=[];
  public vendorArr: any = [];
  public transArr: any = [];
  public isAssigned: any = '';
  public showTable: boolean = true;

  // No data found card variables
  public currentDate: boolean = true;
  public noDataFoundEnable: boolean = false;

  
  public todaysDate:any;
  public tripstartDate:any;

  // Table variabels
  public headers: any = ['#', 'Employee ID', 'Employee name', 'Gender','ETA', 'Check In / Out' ,'Attendance'];
  public mergeHeaders:any=['#', 'Employee ID', 'Employee name', 'Gender','ETA','Mobile number','Address'];

  public rosterTableHeader: any = ['#', 'Employee ID', 'Employee name', 'Gender','ETA', 'Attendance time', 'Action'];
  //Swap Vehicle
  public clickedVehicle:string='';
  public clickedDriverName:string='';
  public clickedDriverNumber:number=0;
  public clickedVendor:string='';
  public showVehicleChanged:Boolean=false;
  public getOldDriverID:string='';
  public getPartTransitMode:string='';
  public getPartVendor:string='';
  public getShiftTimeStr:string = '';
  
  public clickedVehData:any={};
  public vehSwapForm: any | FormGroup;
  public vehSwapFormSubmit:boolean=false;

  // vehicle API Variables
  public orgID:string='';
  public vendorID:string='';
  public vehicleListArr:any=[];

  // vendor API 
  public userData:any='';
  public vendorInfoArr:any='';
  public vendorObjs:any={}

  // Filter Variables
  public getRegNumber: any = '';
  public gettime: any = '';
  public getAttendance:any='';
  public getTranMode: any = '';
  public convertedTime:any='';
  public getTripstatus:any='';

  // DriverList API
  public getDriverArr:any='';
  public getVendorIdOnly:any='';
  public getVehVendorOnly:any='';
  public finalArr:any=[];

  // Patch Variables
  public patchReasonField :any='';
  public typeFieldShow:boolean = false

  // Fieldchanging Variables
  public selectedVendor:any='';
  public vehDriverId:any='';
  public getNewDriverID:any='';
  public getDriverDetails :any='';

  // Excel Variables
  public getTransitMode: any = '';
  public getShiftTime: any = '';
  public getVendorName: any = '';
  public convertToTime:any='';
  public showFemale:any='';

  public rosterModelTitle:string='Modify Route';
  public rosterRouteEditData:any={};

  //Modify Route
  public editRouteForm:FormGroup;
  public editRouteFormSubmitted:boolean =false;
  public maxDate = new Date().toISOString().slice(0, 10);
  public editEmpList:any=[];
  public isEditRouteSubmitted:boolean=false;
  public selectedShift:any='';
  public editTransMode:String='';
  public editAttendForm:FormGroup;

  //employees
  public employeeEditForm:any;
  public totalEditEmp:any=[];
  public searchEmps:any=[];
  //handling vehicle change
  public isPopupOpen:boolean=false;

  // filters
  searchChangeObserver: any;
  public searchEmpty:boolean=true;
  public searchOptionsWidth:number=0;

  //employee list
  public empList:any=[];
  public selectedRosterId:any = [];

  // public loaderDisplay:any;
  public disableMerge:boolean=false;
  public showRouteEdit:boolean=true;
  public routeEditSubmitEnable:boolean=true;

  public minDate=new Date(new Date());
  public maxEndDate=new Date(new Date());
  public createRouteId:string='';
  public rosterData:any={};

  filterFormLoad() {
    this.filterForm = new FormGroup({
      date: new FormControl(this.todayDate),
      vehRegNo: new FormControl(''),
      transitMode: new FormControl(''),
      shiftTimeStr: new FormControl(''),
      attendance : new FormControl('All')
    })
    this.fieldChange({'value':''},'transitMode')
  }

  fieldChange(e: any, fieldType) {
    let value = e.value;
    if (fieldType == 'vehRegNo') {
      this.getRegNumber = value;
    }
    if (fieldType == 'attendance') {
      this.getAttendance = value;
    }
    if (fieldType == 'shiftTimeStr') {
      this.gettime = value;
    }
    if (fieldType == 'transitMode') {
      this.getTranMode = value;
      if(this.filterForm.value.transitMode =='Pickup'){
        this.filterForm.patchValue({
          attendance:''
        })
      } else if(this.filterForm.value.transitMode ==''){
          this.filterForm.patchValue({
            attendance:'All'
          })
      }else if(this.filterForm.value.transitMode =='Drop'){
        this.filterForm.patchValue({
          attendance:''
        })
      }
    }
  }
  public timeChange:any=''
  convertTime(clk){
  this.timeChange  = new Date(clk).toLocaleTimeString();

   const [time, modifier] = this.timeChange.split(" ");
    let [hours, minutes] = time.split(":");
      if (hours === "12") {
          hours = "00";
      }
      if (modifier === "PM") {
          hours = parseInt(hours, 10) + 12;
      }
      this.convertedTime = `${hours}:${minutes}`
      return this.convertedTime;
    }

  getVendorsAndDriverAndVehicleList(){
      // Get Vehicle List API
      const obj = {
        orgID: this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
        vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
      };
      this.api.transportManagerVehicleList(obj).then((res: any) => {
        if (res && res.status == 'success') {
          if(res && res['data'] && res['data'].length > 0)
          this.vehicleListArr = res['data'];
          this.mergeVehArr = res['data'];
          this.addBranchOptions();
        }
      }).catch((err) => {
        console.log(err);
      });

      // Get Vendor List API
      const vendorObj = {
        orgID: this.userData.orgID
      };
      this.api.transportManagerVendorList(vendorObj).then((res: any) => {
        if(res && res['data'] && res['data'].length > 0 && res['status'] && res['status'] == 'success'){
          this.vendorInfoArr = res.data;

          // Set a dynamic Vendor Obj
          for(let i =0;i < this.vendorInfoArr.length ;i++){
            if(this.vendorInfoArr[i]['vendorName'] && this.vendorInfoArr[i]['vendorID']){
              this.vendorObjs[this.vendorInfoArr[i]['vendorName']] = this.vendorInfoArr[i]['vendorID'];
            }
          }
        }
      }).catch((err) => {
        console.log(err);
      });
      setTimeout(()=>this.assignVehUnderVendors(this.vendorInfoArr,this.vehicleListArr),1000)

      // Get Driver List API
      const driverObj = {
        orgID: this.orgID == null ? this.storage.get('vendorsIdOrgId').orgID : this.orgID,
        vendorID: this.vendorID == null ? this.storage.get('vendorsIdOrgId').vendorID : this.vendorID,
      };
      
      this.api.transportManagerDriverList(driverObj).then((res: any) => {
        if (res && res.status == 'success') {
          if(res && res['data'] && res['data'].length > 0 && res['status'] && res['status'] == 'success'){
            this.getDriverArr = res['data']
          }
        }
      }).catch((err) => {
        console.log(err);
      });
  }
  findDateDiff(first, second) {        
    return Math.round((second - first) / (1000 * 60 * 60 * 24));
  }
  getRouteData() {
    this.api.transportMangerRouteList({}).then((res: any) => {
      if (res.status == 'success') {
        if (res.data.length > 0) {
          res.data.map((route) => {
            if (route.title == 'Login') {
              this.rosterData['Pickup'] = route.routeID;
            }
            else if (route.title == 'Logout') {
              this.rosterData['Drop'] = route.routeID;
            }
          });
        }
      }
    }).catch((err) => console.log(err));
  }
  getRosterDetails(obj) {
    this.getListShift();
    let selectedDate:any=new Date(this.filterForm.value.date);
    selectedDate=selectedDate.getTime();
    let currentDate:any=new Date(this.todayDate.setHours(0, 0, 0, 0));
    currentDate=currentDate.getTime();
    let dateDiff=this.findDateDiff(selectedDate,currentDate);
    this.showRouteEdit = dateDiff<2 ? true : false;
    this.disableMerge = (selectedDate >= currentDate) ? false : true;
    this.tripstartDate = new Date(obj.tripDate).toLocaleDateString("en-us");
    this.todaysDate = new Date().toLocaleDateString("en-us");
    this.api.transportManagerRosterList(obj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res && res['status'] && res['data'].length > 0) {
          this.showTable = true;
              if(this.getTranMode =='Pickup'){
                res.data=res.data.filter((e)=>e.transitMode=='Pickup')
              }else if(this.getTranMode =='Drop'){
                res.data=res.data.filter((e)=>e.transitMode=='Drop')
              }
              if(this.getTripstatus=='start') {
                res.data=res.data.filter((e)=>e.tripStatus=='start')
              }else if(this.getTripstatus=='end') {
                res.data=res.data.filter((e)=>e.tripStatus=='end')
              }
          this.tableData = res['data'];
          this.responseData = res['data'];
          for (let i = 0; i < this.tableData.length; i++) {
            let j;
            let employeeInfo = this.tableData[i]['empInfo'];
            let orderByETA=  this.reqOrderByETA(employeeInfo);
            let femaleEmps=orderByETA.filter(e=>e.gender=='Female');
            if(orderByETA.length==femaleEmps.length){
              this.tableData[i]['allFemale']=true;
              this.tableData[i]['firstFemale']=false;
              this.tableData[i]['lastFemale']=false;
            }else{
              if(orderByETA[0].gender=='Female' && this.tableData[i].transitMode=='Pickup'){
             
                this.tableData[i]['allFemale']=false;
                this.tableData[i]['firstFemale']=true;
                this.tableData[i]['lastFemale']=false;

              }
              else if(orderByETA[orderByETA.length-1].gender=='Female' && this.tableData[i].transitMode=='Drop'){
                this.tableData[i]['allFemale']=false;
                this.tableData[i]['firstFemale']=false;
                this.tableData[i]['lastFemale']=true;
          }
            }
            for (j = 0; j < employeeInfo.length; j++) {
              employeeInfo[j]['isAssigned'] ? this.isAssigned = true : this.isAssigned = false

            }
          }
          if (this.tableData.length > 0) {
            this.getVehiclesOnly(this.responseData);
            this.getShitTimeOnly(this.responseData);
            this.getTransitModes(this.responseData);
            this.filterFunctionalityArea();
            if(this.employeeEditForm && this.selectedShift !=''){
              this.setValuesToEditForm(this.rosterRouteEditData);
            }
          }
          if (this.tableData.length <= 0) {
            this.noDataFoundEnable = true
          }
          if (this.tableData.length > 0) {
            this.currentDate = false;
            this.showTable = true;
          }
          if(this.isPopupOpen){
            let selectedRoute=res.data.filter(e=>e.rosterID==this.rosterRouteEditData.rosterID);
            this.rosterRouteEditData=selectedRoute[0];
          }
        } else {
          this.tableData = [];
          this.noDataFoundEnable = true;
          this.showTable = false;
        }
      } else {
        this.tableData = [];
        this.noDataFoundEnable = true;
        this.showTable = false;
      }
    }).catch((err) => {
      console.log(err);
    })
  }
  reqOrderByETA(data)
          {
              let newArr = data.sort(
              (p1, p2) => (p1.etaStr > p2.etaStr) ? 1 : (p1.etaStr < p2.etaStr) ? -1 : 0);
             return newArr;
        }
  resetFilterForm() {
    this.cancelMerge();
    this.gettime ='';
    this.getRegNumber = '';
    this.getTranMode = '';
    this.filterForm.patchValue({
      date:new Date(),
      vehRegNo: '',
      transitMode: '',
      attendance:'All',
      shiftTimeStr: ''
    })
    this.fieldChange({'value':''},'transitMode')
    this.getRosterDetails({
      tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
      default: true,
    })
  }
  getTransitModes(obj: any) {
    let transitArr = [];
    obj.map((transMod: any) => {
      transitArr.push(transMod['transitMode'])
    })
    if (transitArr.length > 0) {
      this.transArr = this.removeDuplicates(transitArr);
    }
  }

  getVehiclesOnly(obj: any) {
    let vehicleArr = [];
    obj.map((veh: any) => {
      vehicleArr.push(veh['vehRegNo'])
    })
    if (vehicleArr.length > 0) {
      this.vehArrays = this.removeDuplicates(vehicleArr);
    }
  }

  assignVehUnderVendors(ven:any,vehList:any){
    for(let i=0;i < ven.length;i++){
      this.getVendorIdOnly = ven[i]['vendorID']
        for(let j=0;j < vehList.length;j++){
          if(ven[i]['vendorID'] == vehList[j]['vendorID'] ){
            this.finalArr.push(vehList[j])
          }
        }
    }
  }

  getShitTimeOnly(obj: any) {
    let pickupShiftArr = [];
    let dropShiftArr = [];
    if(obj && obj!=''){
      obj.map((shift: any) => {
        if(shift['transitMode']=='Pickup'){
          pickupShiftArr.push(shift['shiftTimeStr'])
        }
        if(shift['transitMode']=='Drop'){
          dropShiftArr.push(shift['shiftTimeStr'])
        }
      })
    }
    if (pickupShiftArr.length > 0 || dropShiftArr.length > 0 ) {
      this.shiftListArr = this.removeDuplicates(pickupShiftArr);
      this.dropShiftArr = this.removeDuplicates(dropShiftArr);
    }
  }
  findWidthOfSearchField(){
    if(document.getElementById('searchDropdown') != null){
      let width=document.getElementById('searchDropdown').offsetWidth;
      this.searchOptionsWidth=width;
    }
  }
  removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }
  removeDuplicateEmployees(originalArray,prop){
    let newArray = [];
     let lookupObject  = {};

     for(let i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
     }

     for(let i in lookupObject) {
         newArray.push(lookupObject[i]);
     }
      return newArray;
  }

  onSubmit() {
    this.filterFormSubmit = true;
    let isValid = this.filterForm.valid;

    if (isValid) {
      let obj = {}
      if (this.filterForm.value.date != '') obj['tripDate'] = new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime();
      obj['default'] = true;
      this.getRosterDetails(obj)
    }
  }

  filterFunctionalityArea(){
      if (this.getRegNumber != '') {
        this.responseData = this.responseData.filter(e => e['vehRegNo'] == this.getRegNumber)
      }
      if (this.gettime != '') {
        this.responseData = this.responseData.filter(e => e['shiftTimeStr'] == this.gettime)
      }
      if (this.getTranMode != '') {
        if(this.getTranMode == 'Pickup'){
          if(this.getAttendance=='Boarded'){
          this.responseData = this.responseData.map((e) =>{
            e['empInfo'] = e['empInfo'].filter((emp:any)=> emp['atten']  )
            if(e['empInfo'].length > 0){
              return e 
            }
          }).filter((item:any) => item != undefined)
          }else if(this.getAttendance=='No Show'){
            this.responseData = this.responseData.map((e) =>{
              e['empInfo']= e['empInfo'].filter((emp:any)=> !emp['atten'] )
              if( e['empInfo'].length > 0){
                return e 
              }
            }).filter((item:any) => item != undefined)
          }
        }
        if(this.getTranMode == 'Drop'){
          if(this.getAttendance=='Safe Drop'){
             this.responseData = this.responseData.map((e) =>{
            e['empInfo']= e['empInfo'].filter((emp:any)=> emp['atten']  )
            if(e['empInfo'].length > 0){
              return e 
            }
          }).filter((item:any) => item != undefined)
          }else if(this.getAttendance=='No Show'){
            this.responseData = this.responseData.map((e) =>{
              e['empInfo']= e['empInfo'].filter((emp:any)=> !emp['atten'] )
              if( e['empInfo'].length > 0){
                return e 
              }
            }).filter((item:any) => item != undefined)
          }
        }
      }
     
        if(this.getTripstatus!= ''){
              if(this.getTripstatus=='start') {
                this.responseData = this.responseData.map((e) =>{
                  e['empInfo']= e['empInfo'].filter((emp:any)=> !emp['status']  )
                  if(e['empInfo'].length > 0){
                    return e 
                  }
                }).filter((item:any) => item != undefined)
                }else if(this.getTripstatus=='end'){
                  this.responseData = this.responseData.map((e) =>{
                    e['empInfo']= e['empInfo'].filter((emp:any)=> !emp['status'] )
                    if( e['empInfo'].length > 0){
                      return e 
                    }
                  }).filter((item:any) => item != undefined)
                }
                else {
                  this.responseData = this.responseData.map((e)=>
                  {
                    e['empInfo']=e['empInfo'].filter((emp:any)=>emp['status'])
                  }).filter((item:any)=> item == undefined)
                }
              }
      this.tableData = this.responseData;
  }

  public vehChangeShow :any ='';
  public getTripStartTime:any='';
  public getTripEndTime:any='';
  public getTripDate:any='';
  public item:any;

  async exportToExcel() {
    let SNo = 1;
    let rowCount = 2; 
    let endCell = 'O'; 
    let data;
    let customizedData = []; 
    let titleRow = { 
      value: ['Trip Log Report'], 
      font: { 
        name: 'Corbel', family: 4, size: 16, bold: true, 
        color: { argb: 'FFFFFFFF' }, 
      }, 
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`, 
      alignment: { 
        cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' }, 
      }, 
      fill: { 
        type: 'pattern', 
        pattern: 'solid', 
        fgColor: { argb: '966462AF' }, 
        bgColor: { argb: 'FFF' } 
      }, 
    } 
    customizedData.push(titleRow); 
    rowCount=rowCount+1;
    let headerRow = 
    { 
      value: ['S No', 'Reg no' , 'Employee ID', 'Employee name','Shift time', 'Gender','Check In / Out', 'Attendance', 'Start time','End time', 'ETA','Trip date', 'Transit mode','Vehicle change status', 'Vendor'], 
      font: { bold: true, size: 12 }, 
      border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } } 
    } 
    customizedData.push(headerRow); 
    rowCount=rowCount+1;
    for (let i = 0; i < this.tableData.length; i++) { 
      let item = this.tableData[i]; 
      this.getTripDate = this.com.timestampToDate(new Date(this.filterForm.value.date).getTime(), 'DMY'); 
      this.getShiftTime = item['shiftTimeStr']; 
      this.getTransitMode = item['transitMode']; 
      this.getVendorName = item['vendor']; 
      this.getVendorName = (this.getVendorName === null) ? this.getVendorName = 'Temporary' : this.getVendorName; 
      this.vehChangeShow = item['vehChangeInfo'] 
  
      this.getTripStartTime = item['tripStartTimeStr'] ? item['tripStartTimeStr'] : '---'; 
      this.getTripEndTime =  item['tripEndTimeStr'] ? item['tripEndTimeStr'] : '---'; 

      if (this.tableData[i]['empInfo'] && this.tableData[i]['empInfo'].length > 0) { 
        // Get Employees only 
        for (let e = 0; e < item['empInfo'].length; e++) { 
          rowCount += 1 
          data = item['empInfo'][e]; 
          this.convertToTime = item['empInfo'][e]['attenTime'] 
          if(this.convertToTime!=''){ 
            this.convertTime(this.convertToTime) 
          }  
          try { 
            let res = { 
              value: [ 
                  SNo ++,
                  item['vehRegNo'] ?  String(item['vehRegNo']): '---',
                data.empRefID ? data.empRefID : '---', 
                data.name ? this.com.convertTitleCase(data.name) : '---', 
                this.getShiftTime ? this.getShiftTime : '---', 
                data.gender ? (data.gender == 'M') ? 'Male' : (data.gender == 'F') ? 'Female' : (data.gender == 'T') ? 'Others' : this.com.convertTitleCase(data.gender) : '---', 
                data.attenTime ? this.convertedTime: '---', 
                this.getTransitMode == 'Pickup' ? (data.atten ?  'Boarded' : 'Not Boarded') : (data.atten ?  'Marked' : 'Not Marked') , 
                this.getTripStartTime ? this.getTripStartTime : '---', 
                this.getTripEndTime ? this.getTripEndTime : '---', 
                data.etaStr ? String(data.etaStr).toUpperCase() : '---', 
                this.getTripDate ? this.getTripDate : '---', 
                this.getTransitMode ? this.getTransitMode:'---', 
                
                // item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---', 
                item['vehChangeInfo'] ? "Vehicle Changed": "---",
                this.getVendorName ? this.getVendorName : '---' 
              ], 
            } 
            customizedData.push(res); 
          } 
          catch (err) { 
            console.log(err) 
          }
        rowCount += 1; 
        }
      } 
    } 
    let excelSheetName = 'Trip Log'; 
    if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; } 
    this.excelData[excelSheetName] = { 
      customizedData: customizedData, 
      data: { 
        columWith:  [{ colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 25 }, { colNo: 5, width: 25 }, { colNo: 6, width: 25 }, { colNo: 7, width: 20 }, { colNo: 8, width: 20 }, { colNo: 9, width: 30 },{ colNo: 10, width: 40},{ colNo: 11, width: 25},{ colNo: 12, width: 25},{ colNo: 13, width: 25},{ colNo: 14, width:30},{ colNo: 15, width:30}] 
      } 
    }; 
    this.downloadExlReport(); 
  } 

  downloadExlReport() { 
    this.excel.generateExcel(this.excelData, 'Trip-Log-Report' + new Date().getTime() + '.xlsx'); 
  } 

  openModel(data){
    this.rosterModelTitle='Vehicle Change';
    this.changeVehBtn=true;
    this.vehSwapForm.reset();
    this.isEditRouteSubmitted=false;
    this.routeEditSubmitEnable=true;
    this.clickedVehData = data;
    this.clickedVehicle = data.vehRegNo;
    this.clickedDriverName= (data.driverInfo?.name && data.driverInfo?.name !=null) ? data.driverInfo?.name : '';
    this.clickedDriverNumber= (data.driverInfo?.number && data.driverInfo?.number !=null) ? data.driverInfo?.number : '';
    this.clickedVendor= (data.vendor === null) ? 'Temporary' : data.vendor;
    if(data.driverInfo.driverID !=''){
      this.getOldDriverID = data.driverInfo.driverID
    }
    this.getPartTransitMode = data.transitMode;
    this.getPartVendor=data.vendor;
    this.getShiftTimeStr = data.shiftTimeStr
    this.vehSwapForm.patchValue({
      driverName: this.clickedDriverName,
      driverNumber: this.clickedDriverNumber,
      vendor: (data.vendor === null) ? 'Temporary' : this.vendorObjs[data.vendor],
      newVehicle:this.finalArr
    });
    if(data?.vendor == null){
      this.vendorObjs['vendor']=data?.vendorID;
    this.fieldChanging({'value':this.vendorObjs['vendor']}, 'vendor');
    }else {   
    this.fieldChanging({'value':this.vendorObjs[data.vendor]}, 'vendor');
    }
    // document.getElementById('openModalBtn')?.click();
  }

  vehSwapFormLoad() {
    this.vehSwapFormSubmit=false;
    this.vehSwapForm = new FormGroup({
      newVehicle: new FormControl('', [Validators.required]),
      driverName: new FormControl('', [Validators.required]),
      driverNumber: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      reason: new FormControl('', [Validators.required,Validators.pattern('^[a-zA-Z0-9-,"" ]{3,1000}$')]),
      vendor: new FormControl('', [Validators.required])
    });
  }
  // Search field Area
  searchSelectResult(field,e){      
    this.vehSwapForm.controls[field].patchValue(e.value);
  }
  // Search Fields
  public fieldOptions=[{  branch:[], isEnable:[{ name:"Active",value:'1'},{ name:"Inactive",value:'0'}]}];         // dropdown option object
  addBranchOptions(){
    if(this.vehicleListArr && this.vehicleListArr.length>0){
      this.vehicleListArr.filter((e)=>{
        let option={name: String(e.vehRegNo).toUpperCase(), value:String(e.vehRegNo).toUpperCase()};
        this.fieldOptions[0].branch.push( option);
      });
    }
  }
  // Click to render the reason
  patchReason(value) {
   this.vehSwapForm.patchValue({
    reason : value
   }) 
  }

  // Navigate to Roster
  wayToRoster(){
    this.route.navigateByUrl('organization/transport-manager/rostering/manage-route/roster')
  }

  public changeVehCheckError = (controlName: string, errorName: string) => {
    return this.vehSwapForm.controls[controlName].hasError(errorName);
  }
  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  closeSwapVehModal(){
    this.rosterModelTitle='Modify Route';
    this.vehSwapFormSubmit=false;
    this.vehSwapForm.reset();
  }

  vehFormSubmit(){
    this.vehSwapFormSubmit=true;
    let obj={};
    obj['tripDate']= new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime();
   if(this.getOldDriverID !=null && this.getOldDriverID !='')  obj['oldDriverID'] = this.getOldDriverID; // Working
    obj['reason']=this.vehSwapForm.value.reason; // Working
    obj['oldVehicle']=this.clickedVehicle;
    obj['newVehicle']=this.vehSwapForm.value.newVehicle;
    obj['newDriverName']=this.vehSwapForm.value.driverName;
    obj['newDriverNumber']= +this.vehSwapForm.value.driverNumber;
    if(this.getNewDriverID && this.getNewDriverID !=null && this.getNewDriverID !='') obj['newDriverID']= this.getNewDriverID;
    obj['rosterID']=this.clickedVehData.rosterID;
    obj['vendor']=this.vehSwapForm.value.vendor; // not working
    obj['transitMode']= this.getPartTransitMode; // Working
    obj['shiftTimeStr'] =  this.getShiftTimeStr
   obj['vehInfo']={};
   obj['oldVehicleInfo'] ={};
   if(this.rosterRouteEditData?.start != null ){
    obj['oldVehicleInfo']['startKM'] = this.rosterRouteEditData?.start['value'];
   }else {
    obj['oldVehicleInfo']['startKM'] = '';
   }
   if( this.rosterRouteEditData?.end != null ){
    obj['oldVehicleInfo']['endKM'] = this.rosterRouteEditData?.end['value'];
   }else {
    obj['oldVehicleInfo']['endKM'] = '';
   }
   if(this.rosterRouteEditData?.tripStatus != null){
    obj['oldVehicleInfo']['tripStatus'] =   this.rosterRouteEditData?.tripStatus;
   }else {
    obj['oldVehicleInfo']['tripStatus'] = 'yet to start';
   }
   this.finalArr.filter((veh:any)=>{
    if(veh.vehRegNo == this.vehSwapForm.value.newVehicle){
      obj['vehInfo']['capacity']=veh.capacity;
      obj['vehInfo']['vehType'] = veh.model;
    }
   });
    if(this.vehSwapForm.valid){
      this.changeVehAPI(obj)
    }
  }

  changeVehAPI(obj:any){
    this.api.transportManagerChangeVehicle(obj).then((res: any) => {
      if(res && res['status'] && res['status'] =='Success' ){
        let successMsg = 'Successfully changed'; //Working Awesome
        this.getRosterDetails({
          tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
          default: true,
        })
        this.swal.swalFunction('success', 'success', successMsg, 2000);
        // document.getElementById('modalCloseBtn').click();
        this.goBackToEdit();
      }
      else{
        let errorMsg = String(res['message']).charAt(0).toUpperCase()+ String(res['message']).slice(1).toLowerCase();
        this.swal.swalFunction('error', 'failure',errorMsg , 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  public changeVehBtn:boolean = true;
  fieldChanging(e:any,name:any){
    if(name == 'vendor'){
     this.finalArr=[];
    this.selectedVendor = e.value; //Vendor Id
    if(this.selectedVendor == ''){
      this.vehSwapForm.patchValue({
        driverName:'',
        driverNumber:'',
        newVehicle:''
     })
    }

    // Render the vehicles under the selected Vendor
     for(let i=0;i < this.vendorInfoArr.length; i++){
      this.getVendorIdOnly = this.vendorInfoArr[i]['vendorID']
      if(this.selectedVendor == this.getVendorIdOnly ){
        for(let j=0;j < this.vehicleListArr.length; j++){
          if((this.getVendorIdOnly == this.vehicleListArr[j]['vendorID']) &&(this.clickedVehicle != this.vehicleListArr[j]['vehRegNo'])){
            this.finalArr.push(this.vehicleListArr[j]);
            this.vehDriverId = this.vehicleListArr[j]['driverID'];
          }
        }
      }
    }
    }
    // Patch the Driver details depends on selected vehicle number
    if(name == 'newVehicle'){
      this.changeVehBtn = false;
      if(this.vehSwapForm.value.newVehicle == ''){
        this.vehSwapForm.patchValue({
          driverName:'',
          driverNumber:'',
       })
      }
      let regNumber = e.value
        let reg = this.vehicleListArr.filter((item:any)=>regNumber ==  item['vehRegNo'])
        let drivID = reg[0]['driverID'] ? reg[0]['driverID'] : '';
        if(drivID !=''){
          this.getDriverDetails = this.getDriverArr.filter((item:any)=> drivID ==  item['driverID'])
            if(this.getDriverDetails[0]['name'] && this.getDriverDetails[0]['mobile']){
              this.getNewDriverID = this.getDriverDetails[0]['driverID'] ? this.getDriverDetails[0]['driverID'] : '';
              this.vehSwapForm.patchValue({
                    driverName:this.getDriverDetails[0]['name'],
                    driverNumber:this.getDriverDetails[0]['mobile'],
              })
            }
        }else {
          this.vehSwapForm.patchValue({ driverName:'', driverNumber:''})
        }
    }
  }
 openRouteEditModel(data){
    let modal=document.getElementById('rosterRouteEditModel');
    modal.classList.add('show');
    modal.style.display = "block";
    this.cancelMerge();
    this.setValuesToEditForm(data);
    this.isPopupOpen=true;
    this.rosterModelTitle='Modify Route';
    document.getElementById('openRosterRouteModalBtn')?.click();
    this.rosterRouteEditData=data;
    this.editEmpList=data.empInfo;
    this.totalEditEmp=data.empInfo;
    this.editAttendForm=new FormGroup({});
    this.editAttendFormload();
  }
  openMergeRouteModel(){
    this.mergeEmpData=this.selectedRouteEmps;
    document.getElementById('openMergeRouteModalBtn')?.click();
  }
  setValuesToEditForm(data){
    this.editTransMode=data.transitMode;
    this.employeeEditForm.patchValue({
      startTime:data.tripStartTimeStr,
      endTime:data.tripEndTimeStr,
      shiftTime:data.shiftTimeStr,
    })
    this.selectedShift=this.convertShiftTime(data.shiftTimeStr);
    let arr=[];
    arr.unshift(this.selectedShift);
    if(this.editTransMode=='Pickup'){
      arr=[...arr,...this.pickupShift];
    }else{
      arr=[...arr,...this.dropShift];
    }
    arr=arr.sort();
    this.pickupShift=this.removeDuplicates(arr);
    this.dropShift=this.removeDuplicates(arr);
  }
  closeRouteEditModel(){
    this.isPopupOpen=false;
    this.editRouteFormSubmitted=false;
    this.isEditRouteSubmitted=false;
    this.routeEditSubmitEnable=true;
    this.pickupShift=[];
    this.dropShift=[];
    this.empList=[];
    this.searchEmps=[];
    this.selectedShift='';
    this.getRosterDetails({
      tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
      default: true,
    })
  }
  deleteEmployee(emp,index){
    let empIndex=this.editEmpList.findIndex(e=>e.employeeID==emp.employeeID);
    if(this.editEmpList.length>1){
      this.editEmpList.splice(index,1);
      this.removeControlEditSelectedEmp(emp,index);
      this.routeEditSubmitEnable=false;
    }else{
      this.deleteRouteAPI(this.rosterRouteEditData.rosterID);
    }
  }
  addNewEmp(){
    this.rosterModelTitle='Add Employee';
    this.searchEmps=[];
    this.empList=[];
    this.searchEmpty=true;
    this.editRouteFormSubmitted=false;
    this.isEditRouteSubmitted=false;
    setTimeout(()=>{
      this.findWidthOfSearchField();
    },100)
  }
  addFormLoad() {
    for(let i=0;i<this.empList.length;i++){
      this.editRouteForm.addControl('eta'+this.empList[i].empRefID,new FormControl('', [Validators.required]));
      this.editRouteForm.addControl('attendTime'+this.empList[i].empRefID,new FormControl(''));
    }
  }
  editAttendFormload(){
    for(let i=0;i<this.totalEditEmp.length;i++){
      let name='attendTime'+this.totalEditEmp[i].empRefID;
      if(this.totalEditEmp[i]['attenTime']){
        this.editAttendForm.addControl(name,new FormControl(this.convertTime(this.totalEditEmp[i]['attenTime']), [Validators.required]));
      }else{
        this.editAttendForm.addControl(name,new FormControl(''));
      }
    }
  }
  goBackToEditEmp(){
    this.rosterModelTitle='Modify Route';
    this.editRouteFormSubmitted=false;
    this.editRouteForm.reset();
  }
  employeeCheckError = (controlName: string, errorName: string) => {
    return this.employeeEditForm.controls[controlName].hasError(errorName);
  }
  addEditEmployeeForm(){
    this.employeeEditForm=new FormGroup({});
    this.employeeEditForm.addControl('startTime',new FormControl('', [Validators.required]));
    this.employeeEditForm.addControl('endTime',new FormControl('', [Validators.required]));
    this.employeeEditForm.addControl('shiftTime',new FormControl('', [Validators.required]));
  }
  getEditAttendanceTime(e,emp,id){
    this.routeEditSubmitEnable=false;
    let empIndex=this.totalEditEmp.findIndex(a=>a.employeeID==emp.employeeID);
    if(empIndex !=-1){
      this.totalEditEmp[empIndex]['attenTime']=this.editAttendForm.value[id]?this.convertTimeToMilli(this.editAttendForm.value[id]):'';
      if(this.editAttendForm.value[id]){
        this.totalEditEmp[empIndex]['atten']=true;
      }else{
        delete this.totalEditEmp[empIndex]['attenTime'];
        delete this.totalEditEmp[empIndex]['atten'];
      }
    }
  }
  submitEditRoute(){
    this.isEditRouteSubmitted=true;
    if(this.employeeEditForm.valid && this.editAttendForm.valid){
      this.routeEditSubmitEnable=false;
      this.dropShift=[];
      this.empList=[];
      for(let i=0;i<this.totalEditEmp.length;i++){
        for(let j=0;j<this.editEmpList.length;j++){
          if(this.totalEditEmp[i].employeeID == this.editEmpList[j].employeeID){
            this.totalEditEmp[i]['isAssigned']=true;
          }
        }
      }
      let obj={
        rosterID :this.rosterRouteEditData.rosterID,
        routeID :this.rosterRouteEditData.routeID,
        tripEndTimeStr:this.employeeEditForm.value.endTime,
        tripStartTimeStr:this.employeeEditForm.value.startTime,
        shiftTimeStr:this.employeeEditForm.value.shiftTime,
        empInfo:this.totalEditEmp
      };

      this.api.transportManagerRouteEdit(obj).then((res: any) => {
        if(res.status =='success' ){
          this.swal.swalFunction('success', 'success', res.message, 2000);
          document.getElementById('editRouteCloseBtn').click();
          this.getRosterDetails({
            tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
            default: true,
          })
        }
        else{
          this.swal.swalFunction('error', 'failure',res.message , 2000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  editRouteCheckError = (controlName: string, errorName: string) => {
    return this.editRouteForm.controls[controlName].hasError(errorName);
  }
  editAttendanceCheckError = (controlName: string, errorName: string) => {
    return this.editAttendForm.controls[controlName].hasError(errorName);
  }
  goBackToEdit(){
    this.rosterModelTitle='Modify Route';
    this.editRouteFormSubmitted=false;
    this.setValuesToEditForm(this.rosterRouteEditData);
    this.isEditRouteSubmitted=false;
    if(this.editRouteForm) this.editRouteForm.reset();
    this.vehSwapFormSubmit=false;
    if(this.vehSwapForm) this.vehSwapForm.reset();

    if(this.rosterModelTitle=='Add Employee'){
      this.searchEmpty=true;
      this.editRouteFormSubmitted=false;
      this.editRouteForm.reset();
    }
  }
  addEmployee(){
    this.editRouteFormSubmitted=true;
    if(this.editRouteForm.valid){
    this.routeEditSubmitEnable=false;
      let arr=[];
      for(let i=0;i<this.empList.length;i++){
        let obj={
          address:this.empList[i].address,
          empRefID:this.empList[i].empRefID,
          employeeID:this.empList[i].employeeID,
          eta:this.etaStrToEta(this.empList[i].etaStr),
          etaStr:this.empList[i].etaStr,
          gender:this.empList[i].gender,
          location:this.empList[i].location,
          mobile:this.empList[i].mobile,
          name:this.empList[i].name,
        }
        if(this.empList[i]['attenTime']){
          obj['attenTime']=this.convertTimeToMilli(this.empList[i]['attenTime']);
          obj['atten']=this.empList[i]['atten'];
        }
        arr.push(obj);
      }
      this.editEmpList=[...this.editEmpList, ...arr];
      this.totalEditEmp=this.editEmpList;
      this.editAttendFormload();
      this.goBackToEdit();
      this.searchEmpty=true;
    }
  }
  etaStrToEta(eta){
    let arr=eta.split(':');
    let etaNum=arr.join('.');
    return Number(etaNum);
  }
  onSearchChange(searchValue){
    this.findWidthOfSearchField();
    this.editRouteFormSubmitted=false;
    this.mergeAddEmpFormSubmitted=false;
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        // .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          // if (String(term).length <= 1){
          //   this.searchEmpty=true;
          //   this.searchEmps=[];
          //   this.mergeSearchEmps=[];
          //   this.editRouteFormSubmitted=false;
          // } 
          // else if (String(term).length >= 2){
          //   this.searchEmpty=false;
          // }
          if (String(term).length != 1){
            this.getEmployeeList(term);
          }  

        });
    }

    this.searchChangeObserver.next(searchValue);
  }
  selectEmployees(emp,index){
    if(emp.location){
      let empIndex=this.empList.findIndex(e=>e.employeeID==emp.employeeID);
      if(empIndex == -1){
        this.empList.push(emp);
      }
      this.addFormLoad();
    }
  }
  getEmployeeList(search){
    this.editRouteForm=new FormGroup({});
    this.mergeAddEmpForm=new FormGroup({});
    this.searchEmps=[];
    this.mergeSearchEmps=[];
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
    };
    if (search) obj['search'] = search;
    this.api.transportManagerEmployeeList(obj).then((res: any) => {
      if (res.status == 'success') {
        if(this.addEmpFormCntrl){
          this.mergeSearchEmps=res.data.filter(({ employeeID: id1 }) => !this.mergeEmpData.some(({ employeeID: id2 }) => id2 === id1));
        }else if(this.isThisCreate){
          this.mergeSearchEmps=res.data.filter(({ employeeID: id1 }) => !this.createRosterEmps.some(({ employeeID: id2 }) => id2 === id1));
        }else{
          this.searchEmps=res.data.filter(({ employeeID: id1 }) => !this.editEmpList.some(({ employeeID: id2 }) => id2 === id1));
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  removeControlEditSelectedEmp(emp,index){
    this.editAttendForm.removeControl('attendTime'+emp.empRefID);
  }
  removeSelectedEmp(index,emp){
    let employees=this.empList.splice(index,1);
    this.editRouteForm.removeControl('eta'+emp.empRefID);
    this.editRouteForm.removeControl('attendTime'+emp.empRefID);
  }
  getEta(e,employee,id){
    let empIndex=this.empList.findIndex(a=>a.employeeID==employee.employeeID);
    if(empIndex !=-1){
      this.empList[empIndex]['etaStr']=this.editRouteForm.value[id] ?this.editRouteForm.value[id] :'';
      this.empList[empIndex]['attenTime']='';
    }
  }
  convertTimeToMilli(time){
    var date = new Date();
    date.setHours(time.substring(0,2));
    date.setMinutes(time.substring(3,5));
    var timestamp = date.getTime();
    return timestamp;
  }
  getAttendanceTime(e,employee,id){
    let empIndex=this.empList.findIndex(a=>a.employeeID==employee.employeeID);
    if(empIndex !=-1){
      this.empList[empIndex]['attenTime']=this.editRouteForm.value[id]?this.editRouteForm.value[id]:'';
      if(this.editRouteForm.value[id]){
        this.empList[empIndex]['atten']=true;
      }else{
        delete this.empList[empIndex]['atten'];
      }
    }
  }
  enableEditRouteSubmit(){
    this.routeEditSubmitEnable=false;
  }

  // Merge Route Implementation
  // Merge area Variables

  public rosMergeForm: any |FormGroup;
  public employeesData:any=[];
  public cheBoxVisible:Boolean=false;
  public submitBtnCntrl:boolean = true;
  public mergeEmpData:any=[];
  public checkBoxSts:any='';
  public mergeVehFormSubmit:boolean = false;
  public mSubmitBtn:boolean=true;
  // public searchChangeObserver: any;
  // public searchInputValue = '';
  // public searchEmpty:boolean =true;
  // public empList:any=[];
  public newEmpsArr:any=[];
  public mergeVehArr:any=[];
  public shiftTimeDatas:any=[];
  public mergeFormCntrl:boolean = true;
  public addEmpFormCntrl:boolean = false;
  public mergeFormNoDataFound:boolean = false;
  public mVendorName:any='';
  public mergeRouteID:any='';
  public getMergeBranch:any='';
  public empArrList:any=[];
  public mVehID:any='';

  public mergeAddEmpForm:FormGroup;
  public mergeAddEmpFormSubmitted:boolean=false;
  public mergeSearchEmps:any=[];
  public selectedRouteEmps=[];

  public showMerge:boolean=false;
  public openMerge:string='close';
  public mergeModelTitle:string='';
  //Merge form Load
  mergeFormLoad() {
    this.mergeVehFormSubmit=false;
    this.rosMergeForm = new FormGroup({
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
      mNewVeh:new FormControl('', [Validators.required]),
      mDrivName:new FormControl('', [Validators.required]),
      mDrivPhNo:new FormControl('', [Validators.required]),
      mShiftTime:new FormControl('', [Validators.required]),
      mTransitMode:new FormControl(this.selectedTransitMode ,),
      // mTransitMode:new FormControl({value:this.mtransitMode ,disabled:true}),
    });
  }
  public merVehError = (controlName: string, errorName: string) => {
    return this.rosMergeForm.controls[controlName].hasError(errorName);
  }

  mergeCheckBox(title){
    this.mergeModelTitle=title;
    this.openMerge=='open'?this.openMerge='close':this.openMerge='open';
    if(this.openMerge=='close'){
      this.cancelMerge();
    }
    this.showMerge=true;
    this.cheBoxVisible=true;
    // if(key =='false'){

    //   this.cheBoxVisible=false;
    //   this.submitBtnCntrl = true;
    // } 
  }
  cancelMerge(){
    this.showMerge=false;
    this.openMerge='close';
    this.isDisabled = false;
    this.cheBoxVisible=false;
    this.submitBtnCntrl = true;
    this.selectedTransitMode = '';
    if(this.tableData && this.tableData.length >0){
      for(let i=0;i<this.tableData.length;i++){
        if(this.tableData[i].checked){
          delete this.tableData[i].checked;
        }
      }
    }
  }
  public isDisabled:boolean = false;
  public allOldEmpsArr:any=[];
  public allEmpsArr:any=[];
  public vehModal:any='';
  public selectedTransitMode:any='';

  checkBoxCntrl(e:any,empObj:any,ind:any){
   let checkBoxSts = e.checked;
      this.mergeRouteID = '';
      this.getMergeBranch ='';
  
      if(checkBoxSts && checkBoxSts == true){
        this.getMergeBranch = empObj['branchInfo'];
        this.mergeRouteID = empObj['routeID'];
        this.selectedTransitMode = empObj['transitMode'];
        empObj['checked'] = checkBoxSts;
      }else{
        delete empObj['checked'];
      }

    if(this.tableData && this.tableData.length > 0){
      let count = 0;
      for(let i = 0;i < this.tableData.length;i++){
        let chkBoxSts = this.tableData[i]['checked'];
        if(chkBoxSts && chkBoxSts == true) {
          count++;
        }
      }
      if(count ==2){
        let filterData =  this.tableData.filter((data:any)=>{
          if(data.checked){
            this.selectedRosterId.push(data.rosterID);
            let arr = [...this.mergeEmpData,...data.empInfo];
            this.mergeEmpData = this.removeDuplicateEmployees(arr,'employeeID');
            this.selectedRouteEmps=this.mergeEmpData;
          } 
        })  
        this.submitBtnCntrl = false;
        this.isDisabled = true;
      }else if(count == 0){
        this.submitBtnCntrl = true;
        this.mergeEmpData = [];
        this.selectedRosterId=[];
        this.isDisabled = false;
        this.selectedTransitMode = "";
      }else{
        this.mergeEmpData = [];
        this.selectedRosterId=[];
        this.submitBtnCntrl = true;
        this.isDisabled = false;
      }
    }
    if(this.mergeEmpData &&  this.mergeEmpData.length <=0) this.mergeFormNoDataFound = true;
    if(this.selectedTransitMode  && this.selectedTransitMode !='') this.rosMergeForm.patchValue({mTransitMode: this.selectedTransitMode })
  }

  // Depending Dropdown
  mergeFieldChange(e:any,fieldName='string'){
    // this.vehModal = '';
    // this.mVendorName = ''; // get Vendor name
    if(fieldName && fieldName == 'mNewVeh'){
      let regNumber = e.value
      let reg = this.mergeVehArr.filter((item:any)=>regNumber ==  item['vehRegNo'])
      this.vehModal = reg[0]['model']; // get veh modal name
      let drivID = reg[0]['driverID'] ? reg[0]['driverID'] : '';
      if( drivID && drivID !=''){
        this.getDriverDetails = this.getDriverArr.filter((item:any)=> drivID ==  item['driverID']);
          if(this.getDriverDetails[0]['name'] && this.getDriverDetails[0]['mobile']){
            this.mVehID = this.getDriverDetails[0]['driverID'] ? this.getDriverDetails[0]['driverID'] : '';
            this.rosMergeForm.patchValue({
              mDrivName:this.getDriverDetails[0]['name'],
              mDrivPhNo:this.getDriverDetails[0]['mobile'],
            })
          }
          let arr=this.vendorInfoArr.filter((name)=>name.vendorID == reg[0]['vendorID']);
          this.mVendorName = arr[0]['vendorName'];
      }else {
        this.mVehID ='';
        this.rosMergeForm.patchValue({ mDrivName:'', mDrivPhNo:''})
      }
    }
    if(fieldName && fieldName =='mShift'){
      this.mSubmitBtn=false;
    }
  }
  mergeRouteCheckError = (controlName: string, errorName: string) => {
    return this.mergeAddEmpForm.controls[controlName].hasError(errorName);
  }
  async mergeVehSubmit(){
      this.mergeVehFormSubmit=true;
      let mergeObj ={}
      // Driver Details
      mergeObj['driverInfo'] = {
        name: this.rosMergeForm.value.mDrivName,
        number: this.rosMergeForm.value.mDrivPhNo
      }
      if(this.mVehID && this.mVehID !=null && this.mVehID !='') {
        mergeObj['driverInfo']['driverID'] = this.mVehID ;
      }else{
        delete mergeObj['driverInfo']['driverID']
      }
      mergeObj['tripDate'] = new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
      mergeObj['startTime'] = this.rosMergeForm.value.startTime;
      mergeObj['endTime'] = this.rosMergeForm.value.endTime; 
      mergeObj['vehRegNo'] = this.rosMergeForm.value.mNewVeh;
      mergeObj['transitMode'] = this.rosMergeForm.value.mTransitMode;
      mergeObj['shiftTime'] = this.rosMergeForm.value.mShiftTime;
      mergeObj['empInfo'] = this.mergeEmpData;
      mergeObj['vendor'] = this.mVendorName;
      mergeObj['vehType'] = this.vehModal;
      mergeObj['routeID'] = this.mergeRouteID;
      mergeObj['branchInfo'] = this.getMergeBranch;
      if(this.rosMergeForm && this.rosMergeForm.valid){
        if(this.selectedRosterId && this.selectedRosterId.length==2){
          let obj1={
            rosterID:this.selectedRosterId[0]
          }
          let obj2={
            rosterID:this.selectedRosterId[1]
          }
          let isRouteDeleted;
          let isMerge=false;
          this.loader.show();
          const initialDeleteRes:any = await this.api.transportManagerRosterRouteDeleteHl(obj1).catch((err)=>{
            this.loader.hide();
          })
          if(initialDeleteRes && initialDeleteRes.status=='success'){
            isRouteDeleted = true;
          }else{
            this.loader.hide();
            isRouteDeleted = false;
            let msg = "Can't able to merge these routes!";
            this.swal.swalFunction('Failure', 'failure',msg , 2000);
          }
          if(isRouteDeleted){
            const secondDeleteRes:any = await this.api.transportManagerRosterRouteDeleteHl(obj2).catch((err)=>{
              this.loader.hide();
            })
            if(secondDeleteRes && secondDeleteRes.status =='success'){
              isMerge = true;
            }else{
              isMerge = false;
              this.loader.hide();
              let msg = "Can't able to merge these routes!";
              this.swal.swalFunction('Failure', 'failure',msg , 2000);
            }
          }
          if(isMerge){
            this.mergeRoute(mergeObj);
          }
          // if(this.mergeModelTitle=='Roster Merge'){
          // }else{
          //   this.mergeRoute(mergeObj);
          // }
        }
      }
    }

  mergeRoute(obj:any) {
    this.api.transportManagerRosterMergeHl(obj).then((res: any) => {
      this.loader.hide();
      if (res.status == 'success') {
        let message = '';
        if(this.mergeModelTitle=='Roster Merge'){
          message = 'Roster merged succesfully';
        }
        this.swal.swalFunction(res.status, 'success', message, 2000);
        document.getElementById('MergeModalClose').click();
        this.mergeEmpData=[];
        this.mergeSearchEmps=[];
        this.getRosterDetails({
          tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
          default: true,
        })
      }else{
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
      }
    }).catch((err) => console.log(err));
  }

  closeMergeRouteForm(){
    this.getRosterDetails({
      tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
      default: true,
    })
    this.cancelMerge();
    this.isDisabled = false;
    this.mergeEmpData=[];
    this.selectedRosterId=[];
    this.mergeVehFormSubmit=false;
    this.rosMergeForm.reset();
    this.mSubmitBtn=true;
    this.rosMergeForm.patchValue({
      startTime:'',
      endTime:'',
      mNewVeh:'',
      mDrivName:'',
      mDrivPhNo:'',
      mTransitMode:'',
      mShiftTime:''
    });
    document.getElementById('MergeModalClose').click();
  }
  
  showEmpForm(hint:any){
    this.mergeSearchEmps=[];
    this.empArrList=[];
    this.mergeAddEmpFormSubmitted=false;
    if(this.mergeAddEmpForm){
      this.mergeAddEmpForm.reset();
    }
    this.searchEmpty=true;
    if(hint && hint =='empForm')
    this.mergeFormCntrl = false;
    this.addEmpFormCntrl = true;
    if(hint && hint =='mergeForm'){
    this.newEmpsArr = [];
    this.empArrList=[];
    this.mergeFormCntrl = true;
    this.addEmpFormCntrl = false;
    }
    setTimeout(()=>{
      this.findWidthOfSearchField();
    },100)
  }
 
  async getListShift() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    await this.api.ListShift(obj).then((res: any) => {
      if (res && res.data && res.data.length > 0 &&  res.status && res.status == 'success') {
        this.shiftTimeDatas = res.data;
        this.getAllShiftTimes(this.shiftTimeDatas)
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  public pickupShift:any=[];
  public dropShift:any=[];
  
  getAllShiftTimes(data:any){
    if(data && data!='' && data.length >0){
      let pickupArr=[];
      let dropArr=[];
      for(let a=0;a<data.length;a++){
          let pickupTime=this.convertShiftTime(data[a]['startTime']);
          let dropTime=this.convertShiftTime(data[a]['endTime']);
          pickupArr.push(pickupTime);
          dropArr.push(dropTime);
        }

        if(pickupArr.length > 0){
          pickupArr.sort();
          this.pickupShift=this.removeDuplicates(pickupArr);
        }
        if(dropArr.length > 0){
          dropArr.sort();
          this.dropShift=this.removeDuplicates(dropArr);
        }
    }
  }
  convertShiftTime(time){
    let arr=time.split(':');
    if(Number(arr[0])<10 && arr[0]){
        arr[0]='0'+arr[0];
    }
    let timeString=arr.join(':');
    return timeString;
  }
  // Add new Employees
  async getNewEmployees(emp:any,i:any){

    let empIndex=this.empArrList.findIndex(e=>e.employeeID==emp.employeeID);
    if(empIndex == -1){
      this.empArrList.push(emp);
    }
    this.mergeEmpFormLoad();
    this.processEmpDetails(this.empArrList);
  }
  mergeEmpFormLoad() {
    this.mergeAddEmpFormSubmitted=false;
    for(let i=0;i<this.empArrList.length;i++){
      this.mergeAddEmpForm.addControl('eta'+this.empArrList[i].empRefID,new FormControl('', [Validators.required]));
    }
  }

  // Delete New Employee (If Mistakesly Added Employees)
  removeEmployee(index,emp){
    let employees=this.empArrList.splice(index,1);
    this.mergeAddEmpForm.removeControl('eta'+emp.empRefID);
  }

  // Modifiy the Employee Obj ==> listRost Obj
  processEmpDetails(emps:any){
 if(emps && emps.length >= 1){
      let arr=[];
      for(let i=0;i<emps.length;i++){
        let obj={
          address:emps[i].address,
          // eta:this.etaStrToEta(emps[i].etaStr) ? this.etaStrToEta(emps[i].etaStr) :'',
          etaStr:emps[i].etaStr,
          email:emps[i].email,
          name:emps[i].name,
          empRefID:emps[i].empRefID,
          employeeID:emps[i].employeeID,
          gender:emps[i].gender,
          project: emps[i].project ? emps[i].project :null,
          location:emps[i].location,
          isAssigned:true,
          userType:emps[i].department,
          area:emps[i].area ? emps[i].area :null,
          landmark:emps[i].landmark ? emps[i].landmark :null,
          mobile:emps[i].mobile,
          failedInput:false,
          // otp:'',//Not Required
        }
        arr.push(obj);
      }
      this.empArrList = arr;
      this.searchEmpty=true;
    }
  }

  inputValidation(){
    let isValid = true;
    for(let i=0;i<this.newEmpsArr.length;i++){
       let getETA = this.newEmpsArr[i]['etaStr'];
       this.newEmpsArr[i]['failedInput'] = false;
      if(getETA =='' || getETA === undefined || getETA === null){
        isValid = false;
        this.newEmpsArr[i]['failedInput'] = true;
      }
    }
    return isValid
  }

  newEmpSubmit(){
    this.mergeAddEmpFormSubmitted=true;
    if(this.mergeAddEmpForm.valid){
      this.mergeEmpData=[...this.mergeEmpData,...this.empArrList];
      this.createRosterEmps=[...this.createRosterEmps,...this.empArrList];
      this.newEmpsArr=[];
      this.mergeSearchEmps=[];
      this.mergeFormCntrl = true;
      this.addEmpFormCntrl = false;
      this.goBackToCreateRoster();
      this.empArrList=[];
    }
  }

  getEmpETA(e,employee,id){
    let empIndex=this.empArrList.findIndex(a=>a.employeeID==employee.employeeID);
    if(empIndex !=-1){
      this.empArrList[empIndex]['etaStr']=this.mergeAddEmpForm.value[id] ?this.mergeAddEmpForm.value[id] :'';
    }
  }


  // Delete Entire Route
  deleteRouteAPI(id){
    let Obj={
      rosterID:id
     }
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to remove this employee!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes, remove it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.api.transportManagerRosterRouteDelete(Obj).then((res: any) => {
          if (res.status == 'success') {
            let modal=document.getElementById('rosterRouteEditModel');
            modal.classList.remove('show');
            modal.style.display = "none";
            this.getRosterDetails({
              tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
              default: true,
            })
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    });
  }
  //For Create Roster
  public createActivePage:string='Create Roster';
  public createRosterFormSubmitted:boolean=false;
  public createRosterForm:FormGroup;
  public createTransMode:string='';
  public createRosterEmps:any=[];
  public isThisCreate:boolean=false;
  public createSelVehModel:string='';
  public createSelDriverId:string='';
  public createSelVendorName:string='';
  public defaultBranch:string='';
  public branchDetails:any=[];
  public driverNoErr:boolean=false;

  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success' && res.data.length>0) {
        let branch=res.data.filter(e=>e.isDefault);
        this.branchDetails=branch;
        this.defaultBranch=branch[0]['branchName'];
      }else{
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  openCreateRouteModel(){
    this.createActivePage='Create Roster';
    document.getElementById('openCreateRosterModalBtn')?.click();
    this.createRosterFormSubmitted=false;
    this.isThisCreate=true;
    this.createRosterEmps=[];
    this.createRosterForm.patchValue({
      branch:this.defaultBranch
    })
  }
  closeCreateRoute(){
    this.createSelDriverId='';
    this.createRosterForm.reset();
    this.createActivePage='';
    this.createRosterFormSubmitted=false;
    this.isThisCreate=false;
    this.createRosterEmps=[];
  }
  createRosterFormSubmit(){
    this.createRosterFormSubmitted=true;
    if(this.createRosterForm.valid){
      let obj ={}
      // Driver Details
      obj['driverInfo'] = {
        name: this.createRosterForm.value.driverName,
        number: this.createRosterForm.value.driverNumber
      }
      if(this.createSelDriverId && this.createSelDriverId !=null && this.createSelDriverId !='') {
        obj['driverInfo']['driverID'] = this.createSelDriverId ;
      }else{
        delete obj['driverInfo']['driverID']
      }
      obj['tripDate'] = this.createRosterForm.value.date?new Date(new Date(this.createRosterForm.value.date).setHours(0, 0, 0, 0)).getTime():'',
      obj['startTime'] = this.createRosterForm.value.startTime?this.createRosterForm.value.startTime:'';
      obj['endTime'] = this.createRosterForm.value.endTime?this.createRosterForm.value.endTime:''; 
      obj['vehRegNo'] = this.createRosterForm.value.vehicle?this.createRosterForm.value.vehicle:'';
      obj['transitMode'] = this.createRosterForm.value.transitMode?this.createRosterForm.value.transitMode:'';
      obj['shiftTime'] = this.createRosterForm.value.shiftTime?this.createRosterForm.value.shiftTime:'';
      obj['empInfo'] = this.createRosterEmps;
      obj['vendor'] = this.createSelVendorName?this.createSelVendorName:'';
      obj['vehType'] = this.createSelVehModel?this.createSelVehModel:'';
      obj['routeID'] = this.createRouteId?this.createRouteId:'';
      // obj['tripsheetID'] = this.createRosterForm.value.tripSheetId?(this.createRosterForm.value.tripSheetId).toUpperCase():'';
      obj['branchInfo'] = {
        branchID:this.branchDetails[0]['branchID'],
        location:this.branchDetails[0]['location'],
        name:this.branchDetails[0]['branchName']
      };
      if(obj['empInfo'].length>0){
        this.createRoute(obj);
      }else{
        this.swal.swalFunction('warning', 'Kindly assign employee!', '', 2000);
      }
    }
  }
  createRoute(obj:any) {
    this.api.transportManagerRosterMerge(obj).then((res: any) => {
      if (res.status == 'success') {
        let message = 'Roster created succesfully';
        this.swal.swalFunction(res.status, 'success', message, 2000);
        document.getElementById('createModalClose').click();
        this.closeCreateRoute();
        this.getRosterDetails({
          tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
          default: true,
        })
      }else{
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
      }
    }).catch((err) => console.log(err));
  }
  goToAddEmp(){
    this.createActivePage='Add Employee';
    setTimeout(()=>{
      this.findWidthOfSearchField();
    },100)
  }
  goBackToCreateRoster(){
    this.createActivePage='Create Roster';
    this.mergeSearchEmps=[];
    this.empArrList=[];
    this.mergeAddEmpFormSubmitted=false;
    this.mergeAddEmpForm.reset();
    this.searchEmpty=true;
  }
  createRosterFormLoad(){
    this.createRosterForm=new FormGroup({
      date: new FormControl('', [Validators.required]),
      vehicle: new FormControl('', [Validators.required]),
      // tripSheetId: new FormControl(''),
      driverName: new FormControl('', [Validators.required,Validators.pattern(/^([A-Za-z ])+(?:\.[a-zA-Z]+?)*$/)]),
      driverNumber:new FormControl('', [Validators.required]),
      branch:new FormControl('', [Validators.required]),
      transitMode:new FormControl('', [Validators.required]),
      shiftTime:new FormControl('', [Validators.required]),
      startTime:new FormControl('', [Validators.required]),
      endTime:new FormControl('', [Validators.required]),
    });
  }
  createRosterCheckError = (controlName: string, errorName: string) => {
    return this.createRosterForm.controls[controlName].hasError(errorName);
  }
  createFieldChange(e,field){
    if(field=='transitMode'){
      let value=e.value;
      this.createTransMode=value;
      this.createRouteId=this.rosterData[value];
      this.createRosterForm.patchValue({
        shiftTime:''
      })
    }else if(field=='vehicle'){
      this.createSelDriverId='';
      let regNumber = e.value
      let reg = this.mergeVehArr.filter((item:any)=>regNumber ==  item['vehRegNo'])
      this.createSelVehModel = reg[0]['model']; // get veh modal name
      let drivID = reg[0]['driverID'] ? reg[0]['driverID'] : '';
      if( drivID && drivID !=''){
        this.getDriverDetails = this.getDriverArr.filter((item:any)=> drivID ==  item['driverID']);
          if(this.getDriverDetails[0]['name'] && this.getDriverDetails[0]['mobile']){
            this.createSelDriverId = this.getDriverDetails[0]['driverID'] ? this.getDriverDetails[0]['driverID'] : '';
            this.createRosterForm.patchValue({
              driverName:this.getDriverDetails[0]['name'],
              driverNumber:this.getDriverDetails[0]['mobile'],
            })
          }
          let arr=this.vendorInfoArr.filter((name)=>name.vendorID == reg[0]['vendorID']);
          this.createSelVendorName = arr[0]['vendorName'];
      }else{
        this.createRosterForm.patchValue({
          driverName:'',
          driverNumber:'',
        })
      }
    }else if(field=='driverNumber'){
      this.createSelDriverId='';
      let value=e.target.value;
      if(value.length>0 && value.length<10){
        this.driverNoErr=true;
      }else{
        this.driverNoErr=false;
      }
    }else if(field=='driverName'){
      let value=e.target.value;
      this.createSelDriverId='';
      let driverName=this.createRosterForm.value.driverName.replace(/ {2,}/g,' ').trim();
      this.createRosterForm.patchValue({
        driverName:driverName
      })
    }
  }
}
